import { useEffect, useState } from "react";
import { Info } from "lucide-react";
import { PaymentConfigForm } from "./components/PaymentConfigForm";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { usePSPConfig } from "../../hooks";

export const PaymentGatewayConfig = () => {
  const remoteUtilityId = useRemoteUtilityId();
  const { data: pspConfig, refetch } = usePSPConfig(remoteUtilityId);

  const [gateways, setGateways] = useState<any[]>([]);
  const [activeGatewayKey, setActiveGatewayKey] = useState<string | null>(null);

  useEffect(() => {
    if (!pspConfig) return;
    const preparedGateways = pspConfig.map((psp) => {
      const key = psp?.organizationName?.toLowerCase();
      return {
        key,
        id: psp?.pspId,
        pspUtilityId: psp?.pspUtilityId ?? null,
        title: psp?.organizationName,
        description: psp?.description ?? "",
        credentials: psp?.pspCredential ?? [], // 👈 raw values only
        version: psp?.version ?? '',
        environment: psp?.environment ?? "",
        apiEndpoint: psp?.apiEndpoint ?? "",
        enabled: psp?.isActive,
        verificationStatus: psp?.verificationStatus,
      };
    });

    setGateways(preparedGateways);
    const active = preparedGateways.find((gateway) => gateway.enabled);
    setActiveGatewayKey(active?.key ?? null);
  }, [pspConfig]);

  const handleToggle = (key: string, value: boolean) => {
    setActiveGatewayKey(value ? key : null);
    refetch();
  };
  function isToggleDisabled(
  activeGatewayKey: string | null,
  gatewayKey: string
): boolean {
  return activeGatewayKey !== null && activeGatewayKey !== gatewayKey;
}
  return (
    <div className="space-y-6 p-6 min-h-screen">
      {gateways.map((gateway) => (
        <PaymentConfigForm
          key={gateway.key}
          pspKey={gateway.key}
          {...gateway}
          disableToggle={isToggleDisabled(activeGatewayKey, gateway.key)}
          onToggle={handleToggle}
          refetch={refetch}
        />
      ))}
      <div className="w-full p-4 flex justify-between items-center bg-gray-50 border rounded-lg">
        <div className="flex gap-4">
          <Info className="text-blue-600 w-5 h-5" />
          <span className="text-gray-500 text-sm">
            Configure at least one gateway, then connect to verify gateway
            functionality
          </span>
        </div>
      </div>
    </div>
  );
};
